export default __webpack_public_path__ + "img/champavatar-873d252f.png";